<template>
  <div :class="ui.root">
    <div :class="ui.wrapper">
      <div v-if="label && !hideLabel" :class="ui.label">
        <Icon v-if="icon" :icon="icon" :class="ui.icon" />
        {{ label }}
      </div>
      <div :class="hideLabel || !label ? ui.valueNoLabel : ui.value">
        <slot>
          <TextEllipsis>{{ value }}</TextEllipsis>
        </slot>
      </div>
    </div>

    <div v-if="copyText || redirectLink" :class="ui.actions">
      <div v-if="copyText" :class="ui.action">
        <Copy :text="copyText" />
      </div>
      <div
        v-if="redirectLink"
        :class="[ui.action, ui.actionRedirect]"
        @click="navigateTo(redirectLink, { open: { target: '_blank' } })"
      >
        <AwIcon name="i-ph-arrow-up-right-bold" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label?: string;
  value?: string;
  copyText?: string;
  redirectLink?: string;
  hideLabel?: boolean;
  icon?: string;
}>();

const ui = {
  root: "mt-1.5 mb-2.5 flex w-full flex-row gap-1 rounded-lg bg-[var(--gray-7)] p-2.5",
  wrapper: "min-w-0 flex-1",
  label: "flex items-center gap-1.5 text-[var(--gray-2)]",
  icon: "text-sm",
  value: "mt-1 font-semibold",
  valueNoLabel: "font-semibold",
  actions: "flex shrink-0 flex-col items-end",
  action: "cursor-pointer text-[var(--gray-2)]",
  actionRedirect: "mt-auto",
};
</script>
